import { render } from "./DistributionApprovalsPage.vue?vue&type=template&id=5fa05918&scoped=true"
import script from "./DistributionApprovalsPage.vue?vue&type=script&lang=js"
export * from "./DistributionApprovalsPage.vue?vue&type=script&lang=js"

import "./DistributionApprovalsPage.vue?vue&type=style&index=0&id=5fa05918&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa05918"]])

export default __exports__